import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';

@Injectable()
export class CommonDbService {

    constructor(private _http: HttpClient,private config:Configuration) { }

    public publishNews(data: any,assicateIds:any) {
        return this._http.post(`${this.config.ServerApiUrl}/timeline/create`, {news:data,associates:assicateIds});       
    }

    public getAllNews(status:any,ids?:any) {
        return this._http.post(`${this.config.ServerApiUrl}/timeline/readAll`,{status:status,ids:ids});
    }
    public removeNews(news:any){
        return this._http.post(`${this.config.ServerApiUrl}/timeline/remove`,news);
    }
    public updateNews(data: any) {
        return this._http.post(`${this.config.ServerApiUrl}/timeline/update`, data);
    }

    public saveImage(data){        
        return this._http.post(`${this.config.ServerApiUrl}/timeline/saveImage`,data);
    }

}
